import { Component, EventEmitter, Output } from '@angular/core'

@Component({
  selector: 'app-user-delete-popup',
  templateUrl: './user-delete-popup.component.html',
  styleUrls: ['./user-delete-popup.component.scss'],
})
export class UserDeletePopupComponent {
  @Output() close = new EventEmitter<void>()

  onClose(): void {
    this.close.emit()
  }

  onDelete(): void {
    console.log('Missing feature: user data deletion logic')
    this.close.emit()
  }
}
